/* SpawnAnything — how an AI figure fights (plan C2, 02.10.2026): new recipes carry `kampf` (the model picks it, see
   UNIT_SCHEMA in recipeSchema.js); older cached recipes and the offline fallback get it from the name and era.
   Pure, no deps: used by main.js statsForRecipe and the tests. */

export const KAMPF = ['nahkampf', 'bogen', 'wurf', 'gewehr', 'laser', 'magie'];
/** weapon key per role (all exist in WEAPONS / ERA_WEAPONS) */
export const KAMPF_WEAPON = { nahkampf: 'schwert', bogen: 'bogen', wurf: 'wurfspeer', gewehr: 'gewehr', laser: 'lasergewehr', magie: 'zauber' };
/** role of an existing weapon (few-shot examples, tests) */
export function kampfOfWeapon(w) {
  if (!w) return 'nahkampf';
  if (/^(bogen|armbrust)$/.test(w)) return 'bogen';
  if (/^(wurfspeer|steinwurf)$/.test(w)) return 'wurf';
  if (/laser|plasmagewehr|railgun/.test(w)) return 'laser';
  if (w === 'zauber') return 'magie';
  if (/gewehr|pistole|muskete|karabiner|^mg$|minigun|kanone|raketen/.test(w)) return 'gewehr';
  return 'nahkampf';
}

// word stems in the name / prompt (lower case, umlauts kept); first match wins, magic before archers before guns
const RULES = [
  ['magie', /zauber|magier|hexe|hexer|wizard|witch|mage\b|sorcer|druide|nekromant|necromanc|gandalf|merlin|dumbledore|saruman|voldemort|harry potter|schamane|shaman|warlock|elementar|feuerbändiger|beschwör/],
  ['bogen', /bogen|archer|bowman|legolas|robin hood|elfen?schütze|jäger|hunter|armbrust|crossbow/],
  ['wurf', /speerwerfer|steinewerfer|werfer|thrower|ninja|shuriken|wurf/],
  ['laser', /laser|blaster|jedi|sith|storm ?trooper|klonkrieger|clone trooper|space ?marine|alien|roboter|robot|cyborg|android|astronaut|weltraum|sci-?fi|zukunft|plasma|phaser/],
  ['gewehr', /gewehr|sniper|scharfschütz|soldat|soldier|cowboy|sheriff|polizist|police|swat|agent|gangster|mafia|pirat|musketier|schütze|gunner|rifle|pistole|commando|kommando|marine\b|james bond|terminator|rambo/],
];
const ERA_DEFAULT = { zukunft: 'laser', moderne: 'gewehr', weltkrieg: 'gewehr' };

/** role from the recipe (`kampf`), else from the name / prompt, else from the era, else close combat */
export function kampfOf(rec, text = '') {
  if (rec && KAMPF.includes(rec.kampf)) return rec.kampf;
  const s = `${text || ''} ${(rec && rec.name) || ''}`.toLowerCase();
  for (const [k, re] of RULES) if (re.test(s)) return k;
  return (rec && ERA_DEFAULT[rec.era]) || 'nahkampf';
}
